import { useEffect, useState } from 'react';

export function useWindowLocation() {
  const [url, setUrl] = useState('');
  useEffect(() => {
    setUrl(window.location.href);
  }, []);
  return url;
}

